import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { form1 } from "../Service/Api";
import { getHeader } from "../config";
const Career = () => {
  useEffect(() => {
    document.title = "Career -  St Peters convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li>Career </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container career_page">
          <div className="row">
            <div className="col-lg-12">
              <h1>Career </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p>
                <a
                  href="https://forms.gle/LG9EoyWXayVFGnR1A"
                  target="_blank"
                  rel="noopener noreferrer">
                  Fill out the Google Form
                </a>
              </p>
            </div>
            <div className="col-lg-12">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/Hiring_STPSFH.jpeg"
                className="hiring_STPSFH "
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Career;
